import { take, fork, all } from 'redux-saga/effects';
import { apiTask } from '../app/sagas';
import { api } from '../app/api';
import * as actions from './profilesActions';

export const getTeachers = apiTask(
  actions.GET_TEACHERS,
  api.get,
  '/evaluation-system/getTeachers.php',
);

export const changeTeacherEdit = apiTask(
  actions.CHANGE_TEACHER_EDIT,
  api.post,
  '/evaluation-system/changeTeacherEdit.php',
);

export const removeTeacher = apiTask(
  actions.REMOVE_TEACHER,
  api.post,
  '/evaluation-system/removeTeacher.php',
);

export function* watchGetTeachers() {
  while (true) {
    const { payload } = yield take(actions.GET_TEACHERS);
    yield fork(getTeachers, payload);
  }
}

export function* watchChangeTeacherEdit() {
  while (true) {
    const { payload } = yield take(actions.CHANGE_TEACHER_EDIT);
    yield fork(changeTeacherEdit, payload);
  }
}

export function* watchRemoveTeacher() {
  while (true) {
    const { payload } = yield take(actions.REMOVE_TEACHER);
    yield fork(removeTeacher, payload);
  }
}

// Root module saga
export function* sagas() {
  yield all([fork(watchGetTeachers), fork(watchChangeTeacherEdit), fork(watchRemoveTeacher)]);
}
